import styled from 'styled-components';
import { BREAK_POINTS } from '@origin-digital/helper';
export var ShowLessThan = styled.div.withConfig({
  displayName: "Show__ShowLessThan",
  componentId: "fz3kxa-0"
})(["@media (min-width:", "){display:none;}"], function (_ref) {
  var breakpoint = _ref.breakpoint;
  return BREAK_POINTS[breakpoint].Min;
});
export var ShowGreaterOrEqualTo = styled.div.withConfig({
  displayName: "Show__ShowGreaterOrEqualTo",
  componentId: "fz3kxa-1"
})(["display:none;@media (min-width:", "){display:block;}"], function (_ref2) {
  var breakpoint = _ref2.breakpoint;
  return BREAK_POINTS[breakpoint].Min;
});